import { Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { AngularCsv } from "angular-csv-ext";
import { finalize } from "rxjs/operators";
import { AuthenticationService } from "../../../../core/authentication/authentication.service";
import { DynamicFormComponent } from "../../../../shared/components/dynamic-form/dynamic-form.component";
import { QuestionBase } from "../../../../shared/components/dynamic-form/question-base";
import { NotificationService } from "../../../../shared/components/notification/notification.service";
import { BulkUploadInterface } from "../../../../shared/types/bulk-upload/bulk-upload.type";
import { UserInfo } from "../../../../shared/types/user-info";
import { CompanyService } from "../company.service";
import { CompanyBulkUploadService } from "./company-bulk-upload.service";
import { data } from "./company-csv.json";

interface CompanyBulkUploadPayload {
  csv: File;
}
interface CsvData {
  name: string;
  type: string;
  status: string;
  partnerIdentifier: string;
}

type CsvArray = CsvData[];

@Component({
  selector: "app-company-bulk-upload",
  templateUrl: "./company-bulk-upload.component.html",
  styleUrls: ["./company-bulk-upload.component.css"],
  providers: [CompanyBulkUploadService],
})
export class CompanyBulkUploadComponent implements OnInit, BulkUploadInterface {
  @ViewChild(DynamicFormComponent) dynamicForm: DynamicFormComponent;

  questions: QuestionBase<string | boolean>[];
  currentUser: UserInfo;
  loading = false;

  constructor(
    private questionsService: CompanyBulkUploadService,
    private companyService: CompanyService,
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService,
    public location: Location,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  ngOnInit() {
    this.questionsService.generateQuestions().subscribe((qs) => {
      this.questions = qs;
    });
  }

  goBack() {
    this.location.back();
  }

  onSubmit(values: CompanyBulkUploadPayload) {
    this.loading = true;
    this.companyService
      .getPutSignedUrl()
      .pipe(finalize(() => this.dynamicForm.enable()))
      .subscribe(
        (r) => {
          this.companyService
            .uploadBatch(r.url, values.csv)
            .pipe(finalize(() => this.dynamicForm.enable()))
            .subscribe(
              () => {
                this.notificationService.success(
                  "New bulk upload scheduled from csv file. You will be notified by email once the file is processed.",
                );
                this.loading = false;
              },
              (_err) => {
                this.notificationService.error("Something went wrong. Try again later");
                this.loading = false;
              },
            );
        },
        (_err) => {
          this.notificationService.error("Something went wrong. Try again later");
          this.loading = false;
        },
      );
  }

  getPartnerData(): string {
    if (this.currentUser.isPartner()) {
      return this.currentUser.partner.partnerIdentifier;
    }
    return "PTR2";
  }

  downloadCSV = (): void => {
    const json: CsvArray = data;
    const headers = ["name", "type", "status", "partnerIdentifier"];
    if (this.currentUser.isPartner()) {
      json.map((object) => {
        object.partnerIdentifier = this.currentUser.partner.partnerIdentifier;
      });
    }
    const options = {
      useHeader: false,
      headers,
      nullToEmptyString: true,
      useBom: false,
    };
    new AngularCsv(json, "company", options);
  };
}
